import React from "react"
import {Row, Col} from "react-bootstrap"
import {H4} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import {Deal} from "@irati/types"
import {BasketTotals} from "@irati/checkout/utils/basket/helper/calculateTotals"
import Total from "../Total"

import {SelectedEmail, ProductList} from "../CommonElements"

interface Props {
  deal: Deal
  email?: string
  walletBalanceToUse?: number
  totals: BasketTotals
  basket: any
  products: any
}

const OrderSummaryTT: React.FC<Props> = ({deal, email, walletBalanceToUse, totals, basket, products}) => (
  <div>
    <Row>
      <Col md={12}>
        <H4 marginTop={3} overflowWrap="break-word">
          {deal.header}
        </H4>
        <Hr />
        {email && deal.emailRequired && <SelectedEmail email={email} />}
        {totals && totals.hasSelectedAProduct && <ProductList data={products} breakdown={basket.breakdown} />}
        {((!!totals.subtotal && totals.subtotal > 0) || (!!walletBalanceToUse && walletBalanceToUse > 0)) && (
          <div>
            <Total total={totals.subtotal} currency={basket.breakdown.total.currency} />
          </div>
        )}
      </Col>
    </Row>
  </div>
)

OrderSummaryTT.defaultProps = {
  email: "",
  walletBalanceToUse: 0,
  totals: {}
}

export default OrderSummaryTT
